import callIcon from "@/assets/icons/phoneBlack.svg";
import styles from "./CallItem.module.scss";

export const CallIcon = () => {
  return (
    <div className={styles.callIcon}>
      <a href="tel:+74951505599">
        <img src={callIcon} alt="call icon" />
        <span>
          Позвонить
        </span>
      </a>
    </div>
  );
};